export default "__VITE_ASSET__KInRqA$E__"